
@if (!chartOnly()) {
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs"
    id="report-nav" [hidden]="reportHasErrors|async">
    <li [ngbNavItem]="1">
      <a ngbNavLink><fa-icon [icon]="faChartBar"></fa-icon>&ensp;{{ 'xml-report.chart.header' | translate }}</a>
      <ng-template ngbNavContent>
        @if ((reportHasErrors | async) === false) {
          <div>
            <spinner [isLoading]="isLoading"></spinner>
            <div id="chart-wrapper" class="d-flex" style="min-height:30px">
              @if (chartOptions | async) {
                <div class="w-100">
                  <highcharts-chart class="w-100 d-block"
                    [Highcharts]="highcharts"
                    [options]="chartOptions|async"
                    [(update)]="chartOptionsIsUpdated"
                  ></highcharts-chart>
                </div>
              }
            </div>
            @if (isLoading.value == false) {
              <div>
                <div class="row">
                  <div class="col-12">
                    <chart-total-sum id="chart-sum" [chartData]="chartData | async"></chart-total-sum>
                  </div>
                  <div class="col-md-8 col-lg-9">
                    <chart-info [zoomScrollIsRelevant]="infoZoomScrollIsRelevant()"
                      [drillDownInfo]="drillDownInfo()"
                      (drillUp)="drillUp.emit()">
                    </chart-info>
                  </div>
                  <div class="col-md-4 col-lg-3">
                    <chart-height (heightChange)="chartHeightChange.emit($event)" [currentHeight]="currentChartHeight()"></chart-height>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink><fa-icon [icon]="faTable"></fa-icon>&ensp;{{ 'xml-report.table.header' | translate }}</a>
      <ng-template ngbNavContent>
        <spinner [isLoading]="isLoading"></spinner>
        <chart-show-table [chartData]="chartData | async" (isLoading)="updateIsLoading($event)"></chart-show-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink><fa-icon [icon]="faTable"></fa-icon><b class="d-inline-block d-md-none">+</b>&ensp;{{ 'xml-report.details.header' | translate }}</a>
      <ng-template ngbNavContent>
        <spinner [isLoading]="isLoading"></spinner>
        <chart-show-detailed-table [chartData]="chartData | async" (getExcel)="getExcel()" (isLoading)="updateIsLoading($event)"></chart-show-detailed-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="4">
      <a ngbNavLink><fa-icon [icon]="faQuestion"></fa-icon>&ensp;{{ 'xml-report.explanation' | translate }}</a>
      <ng-template ngbNavContent>
        <spinner [isLoading]="isLoading"></spinner>
        <div id="description-wrapper">
          <div class="my-4" [innerHTML]="descriptionHtml | async"></div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="5">
      <a class="sql-tab" ngbNavLink>&ensp;</a>
      <ng-template ngbNavContent>
        @if (!productionMode()) {
          <div id="sql-wrapper">
            <button type="button" class="btn btn-sm p-2 float-end" autofocus
              (click)="copySql()"
              [class.btn-outline-primary]="!sqlIsCopied"
              [class.btn-success]="sqlIsCopied">
                <fa-icon [icon]="faCopy" size="lg"></fa-icon>&ensp;{{ 'xml-report.copy-sql' | translate }}
            </button>
            <code #code [innerHtml]="chartData.getValue().sqlString"></code>
          </div>
        }
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
} @else {
  <div [hidden]="reportHasErrors | async">
    <spinner [isLoading]="isLoading"></spinner>
    <div id="chart-wrapper" class="d-flex" style="min-height:30px">
      @if (chartOptions | async) {
        <div class="w-100">
          <highcharts-chart class="w-100 d-block"
            [Highcharts]="Highcharts"
            [options]="chartOptions | async"
            [(update)]="chartOptionsIsUpdated"
          ></highcharts-chart>
        </div>
      }
    </div>
  </div>
}


<div [hidden]="!(reportHasErrors | async)" class="text-center">
  <span class="clearfix"></span>
  <div class="row justify-content-center my-lg-5">
    <div class="col-lg-7 col-md-9">
      <div class="card mx-3">
        <div class="card-header">
          <h4 class="mb-0"><fa-icon [icon]="faInfoCircle" size="lg"></fa-icon></h4>
        </div>
        <div class="card-body">
          @if (!(reportHasBelowMinDataAmount | async)) {
            <div>
              <h5 [innerHTML]="'xml-report.chart.error-msg.default' | translate"></h5>
              <hr>
                <p class="font-italic text-muted">[ {{reportError}} ]</p>
              </div>
            }
            @if (reportHasBelowMinDataAmount | async) {
              <div>
                <h5>{{ 'xml-report.chart.error-msg.minDataAmount.title' | translate }}</h5>
                <hr>
                  <p class="font-italic text-muted">{{ 'xml-report.chart.error-msg.minDataAmount.advice' | translate }}</p>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
